module.exports = __webpack_public_path__ + "img/1-Ringier.1b5ff331.png";